import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const AccountsWorkPlanner = () => {
  return <DepartmentWorkPlanner department="accounts" departmentName="Accounts Department" />;
};

export default AccountsWorkPlanner;
